var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 7.5,
    stroke: "#F7931A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3706 18C24.8214 18 25.1743 17.4362 24.9081 17.0307C23.0814 14.2531 21.3747 13.0841 19.548 10.3075C19.2808 9.90096 18.7392 9.89579 18.472 10.3023C16.6453 13.0799 14.9322 14.2303 13.1055 17.009C12.9709 17.2128 12.976 17.4124 13.0596 17.5738C13.1351 17.8076 13.3411 18 13.6818 18L24.3706 18Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3706 28C24.8214 28 25.1743 27.4362 24.9081 27.0307C23.0814 24.2531 21.3747 23.0841 19.548 20.3075C19.2808 19.901 18.7392 19.8958 18.472 20.3023C16.6453 23.0799 14.9322 24.2303 13.1055 27.009C12.9709 27.2128 12.976 27.4124 13.0596 27.5738C13.1351 27.8076 13.3411 28 13.6818 28L24.3706 28Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.9a92298470b0ce9dd989c8287333dead.svg";
export { ForwardRef as ReactComponent };